import { useContext } from 'react';
import type { TModalContextMinimal } from '../contexts/DocumentCounterpartiesContext';
import { DocumentCounterpartiesContext } from '../contexts/DocumentCounterpartiesContext';

export default function useCounterpartiesContextMin(): TModalContextMinimal {
  return useContext(DocumentCounterpartiesContext);
}
